import { useMemo } from 'react'
import PermissionGrantRepository from './PermissionGrantRepository'

const usePermissionGrantRepository = (pageSize: number = 10, deps?: readonly unknown[]): PermissionGrantRepository => {
  return useMemo(() => new PermissionGrantRepository({ pageSize }), [pageSize, ...(deps ?? [])])
}

export default usePermissionGrantRepository
